var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.8 121.4V27.2L38.0601 27.2V121.4H111.8Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.2 15.2H36.7999C33.1549 15.2 30.2 18.1549 30.2 21.8V128.21C30.2 131.855 33.1549 134.81 36.7999 134.81H113.2C116.845 134.81 119.8 131.855 119.8 128.21V21.8C119.8 18.1549 116.845 15.2 113.2 15.2Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 130.6C74.915 130.6 75.9 129.615 75.9 128.4C75.9 127.185 74.915 126.2 73.7 126.2C72.485 126.2 71.5 127.185 71.5 128.4C71.5 129.615 72.485 130.6 73.7 130.6Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0999 22.3H78.8999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.7cd21141ba400b20b6bac5a4c7b5298e.svg";
export { ForwardRef as ReactComponent };